const initialState = {
  images: [],
};

const getters = {
  imageList: state => [...state.images],
};

const mutations = {
  setImageList(state, list) {
    // eslint-disable-next-line
    state.images = [...list];
  },
};

const actions = {
  setImages({ commit }, list) {
    commit('setImageList', list);
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/memoryGame.js